<template>
  <v-container v-if="variant">
    <v-row class="mb-4 ga-4">
      <v-col
        class="bordered bg-white ml-n2"
        cols="4">
        <v-container class="input_grid">
          <CalcInputNumber
            :id="nodeId"
            field="maintenance_costs_year_machine"
            :rules="[required, positive]" />

          <CalcOutput
            :id="locationId"
            outside-label
            unit="%"
            field="calculated_interest_rate_percentage_location" />

          <CalcOutput
            :id="nodeId"
            outside-label
            unit="€ je Stunde"
            field="maintenance_costs_hour_machine" />
        </v-container>
      </v-col>
      <v-col
        class="bordered bg-white mr-n2"
        cols="4">
        <v-container class="input_grid">
          <CalcInputNumber
            :id="nodeId"
            field="connected_load_machine"
            :rules="[required, positive]" />

          <CalcInputNumber
            :id="nodeId"
            field="power_consumption_machine"
            :rules="[required, positive]" />

          <CalcOutput
            :id="locationId"
            outside-label
            unit="€ je kw/h"
            field="electricity_price_location" />

          <CalcOutput
            :id="nodeId"
            outside-label
            unit="€ je Stunde"
            field="energy_consuption_costs_machine" />
        </v-container>
      </v-col>
      <v-col
        class="bordered bg-white mr-n2"
        cols="4">
        <v-container class="input_grid">
          <CalcInputNumber
            :id="nodeId"
            field="operating_material_costs_year_machine"
            :rules="[required, positive]" />

          <CalcOutput
            :id="nodeId"
            outside-label
            unit="€ je Stunde"
            field="operating_material_costs_hour_machine" />
        </v-container>
      </v-col>
    </v-row>
    <v-row class="bg-white bordered mt-4">
      <v-col cols="6">
        <CalcOutput
          :id="locationId"
          outside-label
          unit="h je Jahr"
          field="machine_availability_after_deductions_location" />
      </v-col>
      <v-col cols="6">
        <CalcOutput
          :id="nodeId"
          outside-label
          unit="€ je Stunde"
          field="variable_costs_machine" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useSpaceStore } from "@/stores/spaceStore";
import CalcOutput from "@/components/Elements/CalcOutput.vue";
import { useTreeStore } from "@/stores/treeStore";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";
import { useTranslation } from "i18next-vue";
import { useCommonRules } from "@/validations/common";

const { t } = useTranslation();
const { required, positive } = useCommonRules(t);
const spaceStore = useSpaceStore();
const treeStore = useTreeStore();

const variant = ref(null);

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

const locationId = computed(() => {
  return treeStore.elementLocation[props.nodeId];
});

onMounted(() => {
  variant.value = spaceStore.getElement(props.nodeId);
});
</script>
